import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import { HeaderVariant } from "../Header.types";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers([
    "container",
    "symbol",
    "logoWrapper",
    "logo",
    "navigation",
    "userArea",
]);
const bottomBorderHeight = "1px";
const headerHeight = { base: "4rem", md: "5rem" };
const baseStyle = definePartsStyle(() => ({
    container: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "space-between",
        height: headerHeight,
        borderBottom: `${bottomBorderHeight} solid`,
        borderColor: "semantic.brand.secondary",
    },
    rightMenu: {
        display: "flex",
        flexDirection: "row",
    },
    symbol: {
        display: { base: "none", md: "block" },
        height: "100%",
        color: "semantic.brand.secondary",
    },
    logoWrapper: {
        background: "semantic.brand.primary",
        display: "flex",
        alignItems: "center",
        position: "relative",
        width: { base: "6.375rem", md: "22.5rem", lg: "17.25rem" },
        marginRight: headerHeight,
        _after: {
            content: '""',
            position: "absolute",
            top: 0,
            right: 0,
            width: 0,
            height: 0,
            transform: "translateX(100%)",
            borderTop: "0rem solid transparent",
            fontSize: headerHeight,
            borderBottom: `calc(1em - ${bottomBorderHeight}) solid`,
            borderBottomColor: "transparent",
            borderRight: `calc(1em - ${bottomBorderHeight}) solid`,
            borderRightColor: "transparent",
            borderLeft: `calc(1em - ${bottomBorderHeight}) solid`,
            borderLeftColor: "semantic.brand.primary",
        },
    },
    logo: {
        width: { base: "2.5rem", md: "7rem" },
        height: "auto",
        marginLeft: 4,
        button: {
            p: 0,
            height: "auto",
            _hover: { background: "inherit" },
            _focusVisible: {
                background: "inherit",
            },
        },
    },
    navigation: {
        flex: 1,
        zIndex: 1,
        display: { base: "none", lg: "flex" },
        justifyContent: "flex-end",
    },
    userArea: {
        height: "100%",
        display: "flex",
        alignItems: "center",
        marginLeft: "auto",
    },
}));
const variants = {
    [HeaderVariant.BO]: definePartsStyle({
        container: {
            borderColor: "semantic.brand.tertiary",
        },
        symbol: {
            color: "semantic.brand.tertiary",
        },
    }),
};
const HeaderTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    defaultProps: {},
});
export default HeaderTheme;
export { headerHeight };
//# sourceMappingURL=Header.default.js.map